// Unified buy logic for all games
import { buyGameCollection, updateBalance } from "../api.js";

/**
 * Unified buy handler for all games.
 * @param {Object} options
 * @param {Object} options.game - The selected game object.
 * @param {Array|undefined} options.buyArguments - Arguments for buyGameCollection (optional).
 * @param {Function|undefined} options.onSuccess - Callback on success (optional, receives API data).
 * @param {Function|undefined} options.onError - Callback on error (optional, receives error).
 * @param {Function|undefined} options.onFinally - Callback always called (optional).
 * @param {Function|undefined} options.refreshTickets - Function to refresh tickets (optional).
 * @param {Function|undefined} options.refreshBalance - Function to refresh balance (optional).
 * @param {Function|undefined} options.setLoading - Function to set loading state (optional).
 */
export async function unifiedBuy({
  game,
  buyArguments,
  buyOverrides = {},
  onSuccess,
  onError,
  onFinally,
  refreshTickets,
  refreshBalance,
  setLoading,
}) {
  if (!game) return;
  if (!buyArguments) {
    // Inline buildBuyArgument logic
    const t =
      (game &&
        game.buyTicketMeta &&
        Array.isArray(game.buyTicketMeta.buyArguments) &&
        game.buyTicketMeta.buyArguments[0]) ||
      null;
    if (!t) {
      if (onError) onError("Buy-template saknas för valt spel.");
      return;
    }
    const arg = Object.assign({}, t, buyOverrides);
    buyArguments = [arg];
  }
  if (setLoading) setLoading(true);
  try {
    const data = await buyGameCollection(game.id, buyArguments);
    if (onSuccess) onSuccess(data);
    if (refreshTickets) await refreshTickets();
    if (refreshBalance) await refreshBalance();
    else await updateBalance();
  } catch (err) {
    if (onError) onError(err);
  } finally {
    if (setLoading) setLoading(false);
    if (onFinally) onFinally();
  }
}
